import { render, staticRenderFns } from "./Topbar.vue?vue&type=template&id=897f7af8&scoped=true"
import script from "./Topbar.vue?vue&type=script&lang=js"
export * from "./Topbar.vue?vue&type=script&lang=js"
import style0 from "./Topbar.vue?vue&type=style&index=0&id=897f7af8&prod&lang=scss"
import style1 from "./Topbar.vue?vue&type=style&index=1&id=897f7af8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "897f7af8",
  null
  
)

export default component.exports